import { ApiHandler } from "@insite/client-framework/HandlerCreator";
import { HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { AddProductApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    DispatchCompleteAddingProductToCart,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { AddToCart } from "@SupplyLand/Utilities/customTracking";

type AddToCartParameter = {
    onError?: (error: string) => void;
} & AddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter, CartLineModel>;

export const TrackAddToCart: HandlerType = props => {
    const item = { unitListPrice: props.apiResult.pricing?.unitListPrice, productNumber: props.apiResult.productName };
    AddToCart(item, props.apiParameter.qtyOrdered);
};
addToChainAfter(chain, DispatchCompleteAddingProductToCart, TrackAddToCart);
